import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  ElementRef,
  input,
} from '@angular/core';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-section-header',
  imports: [TuiIcon],
  templateUrl: './section-header.component.html',
  styleUrl: './section-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeaderComponent {
  public readonly icon = input<string | undefined>(undefined);
  public readonly subtitle = input<string | undefined>(undefined);
  public readonly title = input.required<string>();
  public readonly descriptionInput = input<string | undefined>(undefined, {
    alias: 'description',
  });
  public readonly descriptionContentChild = contentChild<
    ElementRef | undefined
  >('description');
}
